import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../Button/Button';
import Icon from '../Icon/Icon';
import Modal from '../Modal';
import styles from './SubmitForReviewModal.module.scss';

const SubmitForReviewModal = ({ isShow, submitVideo, isSubmitLoading, onClose }) => {
  const { t } = useTranslation();

  const handleSubmit = async () => {
    await submitVideo();
    onClose();
  };

  return (
    <Modal className={styles.modal} open={isShow} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>{t('review.submit_for_review_modal.title')}</span>
          <Icon src="close" className={styles.closeIcon} onClick={onClose} />
        </div>
        <div className={styles.text}>
          <span>{t('review.submit_for_review_modal.text')}</span>
        </div>
        <div className={styles.buttonsContainer}>
          <CustomButton
            className={styles.removeBtn}
            variant="primary"
            label={t('general.video_action_button.submit_for_review')}
            onClick={handleSubmit}
            loading={isSubmitLoading}
            loadingSpinner={true}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SubmitForReviewModal;
